class LocalizationForm extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
            button: this.querySelector('.disclosure'),
            panel: this.querySelector('ul'),
            close: this.querySelector('.disclosure__item--back'),
            links: this.querySelectorAll('.disclosure__item-link'),
            form: this.querySelector('form')
        };
    }
    connectedCallback(){
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.elements.button.addEventListener('mouseover', this.openSelector.bind(this));
        this.elements.button.addEventListener('mouseout', this.closeSelector.bind(this));
        //this.elements.links.forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        this.elements.links.forEach((item) => item.addEventListener('click', (event) => this.onItemClick(event)));
        this.elements.links.forEach((item) => item.addEventListener('mousedown', (event) => this.onItemClick(event)));

        if (!this.elements.close) return;

        this.elements.close.addEventListener('click', () => this.hidePanel());
    }
    hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
    }
    onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        this.hidePanel();
        this.elements.button.focus();
    }

    onOpen(event){
    }

    onItemClick(event) {
        event.preventDefault();
        this.elements.input.value = event.currentTarget.dataset.value;
        this.elements.form.submit();
    }

    openSelector() {
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
        this.hidePanel();
    }
}
class LocalizationFormMobile extends LocalizationForm {
    constructor(){
        super();
    }
}
class LocalizationFormDesktop extends LocalizationForm {
    constructor(){
        super();
    }
}
customElements.define('localization-form-desktop', LocalizationFormDesktop);
customElements.define('localization-form-mobile', LocalizationFormMobile);
